import React from 'react'
import firebase from 'firebase/app'

let LogoutBtn = ({ setLoggedIn }) => {
  return (
    <button
      title="Log out"
      className="btn btn-link text-white"
      onClick={() => {
        setLoggedIn(false)
        firebase.auth().signOut()
      }}
    >
      <i className="fa fa-sign-out" />
    </button>
  )
}

export default LogoutBtn
